<script lang="ts">
	import SiteSns from "../../organisms/settings/SiteSns.svelte";
</script>

<div class="flex">
	<div class="flex-1 mr-8">
		<SiteSns/>
	</div>
</div>